<template>
  <ComponenteCatalogoAtivo :titulo="'interno'" />
</template>

<script>
import ComponenteCatalogoAtivo from "../components/ComponenteCatalogoAtivo.vue";

export default {
  components: {
    ComponenteCatalogoAtivo,
  },
  setup() {
    return {};
  },
};
</script>
